<script setup lang="ts">
import type { Schemas } from "#shopware";
import SwSharedPrice from "~/components/shared/SharedPrice.vue";
import {useProductPrice} from "#imports";
import {computed} from "vue";

const props = defineProps<{
  product: Schemas["Product"];
}>();
const { product } = toRefs(props);

const { unitPrice, displayFromVariants, displayFrom, price, isListPrice } =
  useProductPrice(product);

const regulationPrice = computed(() => price.value?.regulationPrice?.price);
</script>

<template>
  <div :id="product.id">
    <span
        v-if="isListPrice"
        class="text-sm font-normal text-arsenic flex items-center mt-1"
    >

          <SwSharedPrice
              class="text-sm font-normal text-arsenic line-through"
              :value="price?.listPrice?.price"
          />
    </span>
    <SwSharedPrice
        v-if="unitPrice"
        class="text-2xl md:text-xl font-bold text-black"
        :class="{
            'text-maximum-red': isListPrice,
          }"
        :value="unitPrice"
    />
    <div v-if="regulationPrice" class="text-xs flex text-secondary-500">
      {{ $t("productDetails.previously") }}
      <SwSharedPrice class="ml-1" :value="regulationPrice" />
    </div>
    <div v-if="!regulationPrice && !unitPrice" class="text-xs text-secondary-500">
      <span class="px-1.5"><i class="fa fa-xl fa-xmark"></i> </span>
      <span>{{ $t("productDetails.noAvailableCard") }}</span>
    </div>
  </div>
</template>
